import styled from "@emotion/styled";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

export const AgentSectionHeader = ({ title, count }: { title: string; count?: number }) => (
  <StyledHeader>
    <MDSText color={MDSTextColor.Secondary} variant={MDSTextVariant.TextXs}>
      {title.toUpperCase()}
    </MDSText>
    {count !== undefined ? (
      <MDSText color={MDSTextColor.Tertiary} variant={MDSTextVariant.TextXs}>
        {count}
      </MDSText>
    ) : null}
  </StyledHeader>
);

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};
  padding-left: ${({ theme }) => theme.spacing[3]};
`;
